import { ChangeEvent, ReactNode, useCallback } from 'react'
import L3Select from '../l3/L3Select'
import { useConceptStatus } from '../../../redux/selectConceptStatus2'
import { useFormDispatch } from '../../../redux/formStoreHooks'
import L1ErrorBlock from '../l1/L1ErrorBlock'
import { submitStatusUpdates } from '../../../redux/submitStatusUpdates'
import { ConceptStatusValueType, ConceptValueDataType } from '@fusion-advantage/backcompat'
import { ConceptStatusUpdate, isSuperconceptStatus } from '@fusion-advantage/formlib'
import { useConceptValidator } from './useConceptValidator'

interface L4SelectProps {
	cid?: string,
	children?: ReactNode,
	nullOption?: boolean,
}

const L4Select = ({cid, children, nullOption = true}: L4SelectProps) => {
	const { errorNode } = useConceptValidator({
		tagName: 'L4Select',
		cid,
		requireConcept: true,
		allowDataTypes: [ConceptValueDataType.Radios],
	})
	const conceptStatus = useConceptStatus(cid)
	const dispatch = useFormDispatch()
	const handleChange = useCallback((e: ChangeEvent<HTMLSelectElement>) => {
		let update: ConceptStatusUpdate
		if(e.target.value) {
			update = {
				cid: cid!,
				subconceptCid: e.target.value,
				value: true,
				valueType: ConceptStatusValueType.Chosen,
			}
		} else {
			update = {
				cid: cid!,
				value: null,
				valueType: ConceptStatusValueType.Chosen,
			}
		}
		dispatch(submitStatusUpdates([update]))
	}, [dispatch, cid, conceptStatus])
	if(errorNode) {
		return errorNode
	}
	if(conceptStatus && !isSuperconceptStatus(conceptStatus)) {
		// probably passed ConceptStatus instead of SuperconceptStatus
		// which doesn't make sense for this control
		return <L1ErrorBlock content={`[L4Select] conceptStatus !isSuperconceptStatus`} />
	}
	return (
		<L3Select
			conceptStatus={conceptStatus}
			onChange={handleChange}
			nullOption={nullOption}
		>
			{children}
		</L3Select>
	)
}

export default L4Select
